var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { initialState } from './initialState';
import { ACTION_CONTRACTS as actionTypes } from '../utils/constants';
export default function (state, action) {
  if (state === void 0) {
    state = initialState.contractsGrid;
  }

  switch (action.type) {
    case actionTypes.SET_SHIPPING_DATA:
      {
        var _a = action.payload,
            previewShippingCosts = _a.previewShippingCosts,
            shippingCostPreview = _a.shippingCostPreview;
        var headers = {
          pinned: {
            name: 'Quantity',
            value: 'Quantity'
          },
          headerList: [{
            name: shippingCostPreview.title,
            value: 'ShippingCost'
          }]
        };
        var rowData = previewShippingCosts.map(function (shippingRow) {
          return {
            Quantity: shippingRow.quantity,
            ShippingCost: shippingRow
          };
        });
        return __assign(__assign({}, state), {
          headers: headers,
          rowData: rowData
        });
      }

    case actionTypes.SET_PRODUCT_PRICE_DATA:
      {
        var _b = action.payload,
            previewPrice_1 = _b.previewPrice,
            column_1 = _b.column,
            resolvedAttributes_1 = _b.resolvedAttributes,
            selectedRow = _b.selectedRow;
        var headers = {
          pinned: {
            name: 'Quantity',
            value: 'Quantity'
          },
          headerList: [{
            name: column_1.title,
            value: column_1.title
          }]
        };
        var rowData = null;

        if (selectedRow && selectedRow.selectedValues && selectedRow.selectedValues.length) {
          var selectedValues = selectedRow.selectedValues;
          rowData = selectedValues.map(function (quantity) {
            var _a;

            var pricedQuantity = resolvedAttributes_1 && resolvedAttributes_1.find(function (row) {
              var key = row.key;
              var resolvedQuantity = key.split('|')[1];
              return quantity === resolvedQuantity;
            });
            var priceCell = null;

            if (!pricedQuantity) {
              priceCell = {
                quantity: quantity,
                productPrice: {
                  displayPrice: null,
                  currency: null
                }
              };
            } else {
              var displayPrice = null;
              var currency = null;

              if (previewPrice_1) {
                var price = previewPrice_1[quantity];
                displayPrice = price.amount;
                currency = price.currency;
              }

              priceCell = {
                quantity: quantity,
                productPrice: {
                  displayPrice: displayPrice,
                  totalPrice: displayPrice,
                  currency: currency
                }
              };
            }

            return _a = {
              Quantity: quantity
            }, _a[column_1.title] = priceCell, _a;
          });
        }

        return __assign(__assign({}, state), {
          headers: headers,
          rowData: rowData
        });
      }

    case actionTypes.CLEAR_GRID_DATA:
      {
        return __assign(__assign({}, state), {
          headers: null,
          rowData: null
        });
      }

    default:
      return state;
  }
}